"use strict";

export class RequestUtil {
  // Example POST method implementation:
  static async postData(url: string = "", data: any = {}, xIssuerId: string, xUserId: string, token: string): Promise<any> {
    // Default options are marked with *
    const response = await fetch(url, {
      method: "POST", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      headers: {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json;charset=UTF-8",
        "X-Issuer-Id": xIssuerId,
        "X-User-Id": xUserId,
        "X-Request-Id": "default#4107309564#4321432143"+(Math.random() + " ").substring(2, 8),
        Authorization: "Bearer " + token,
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      body: JSON.stringify(data), // body data type must match "Content-Type" header
    });
    return response.json(); // parses JSON response into native JavaScript objects
  }

  static async getData(url: string = "", xIssuerId: string, xUserId: string, token: string): Promise<any> {
    // Default options are marked with *
    const response = await fetch(url, {
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      credentials: "omit",
      headers: {
        Accept: "application/json, text/plain, */*",
        "Accept-Language": "en-US",
        "Content-Type": "application/json",
        "X-Issuer-Id": xIssuerId,
        "X-User-Id": xUserId,
        Authorization: "Bearer " + token,
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: "follow", // manual, *follow, error
      //referrerPolicy: 'no-referrer', // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
      //body: JSON.stringify(data) // body data type must match "Content-Type" header
    });
    return response.json(); // parses JSON response into native JavaScript objects
  }

  static async getDataHTML(url: string = "", xIssuerId: string, xUserId: string, token: string): Promise<Response> {
    // Default options are marked with *
    const response = await fetch(url, {
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      credentials: "omit",
      headers: {
        Accept: "application/json, text/html, */*",
        "Accept-Language": "en-US",
        "Content-Type": "application/json",
        "X-Issuer-Id": xIssuerId,
        "X-User-Id": xUserId,
        Authorization: "Bearer " + token,
      },
      redirect: "follow",
      referrerPolicy: "origin-when-cross-origin",
    });
    return response; // parses JSON response into native JavaScript objects
  }
}
